import { handleActions } from 'redux-actions';
import { types } from './smartfill.meta';

const initialState = { data: {} };
export function clearSmartfillData() {
  return initialState;
}
export function fetchSmartfillData(state, action) {
  const { payload } = action;
  return {
    data: { ...payload },
  };
}

export function fetchSmartfillDataCompleted(state, action) {
  const { payload } = action;
  return {
    data: { ...payload },
  };
}

export default handleActions(
  {
    [types.UPDATE_SMARTFILL_DATA]: fetchSmartfillData,
    [types.UPDATE_SMARTFILL_COMPLETED]: fetchSmartfillDataCompleted,
  },
  initialState
);
